module.exports = __webpack_public_path__ + "static/media/unitedhealthcare.c6ae6e5b.png";